import { combineReducers } from 'redux';
import expenseReducer from './reducers';

const rootReducer = combineReducers({
  auth: expenseReducer
});

export default rootReducer;